import CreateAiResistantHomeworkIdeasView from "@features/tools/view/ai-resistant-homework-ideas/create-ai-resistant-homework-ideas";

const CreateAiResistantHomeworkIdeas = () => {
  return <CreateAiResistantHomeworkIdeasView />;
};

export default CreateAiResistantHomeworkIdeas;
